var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wizard-price-base',{attrs:{"label":_vm.label,"editable":_vm.$attrs.editable,"pre-value-token":"Ø","post-value-token":"pro m²","max-price":_vm.maxPrice},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }